// extracted by mini-css-extract-plugin
module.exports = {"time":"FeelingEvaluationPeriodInput_time__1ecGQ","choiceIcon":"FeelingEvaluationPeriodInput_choiceIcon__1zVOS","choiceLabel":"FeelingEvaluationPeriodInput_choiceLabel__2VEWk"};